<template>
  <div class="modal-backdrop-custom">
    <div class="modal-card card shadow" style="width: 520px;">
      <div class="card-header d-flex justify-content-between align-items-center">
        <strong>{{ title }}</strong>
        <button class="btn btn-sm btn-outline-secondary" @click="$emit('close')">X</button>
      </div>

      <div class="card-body">
        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <div class="mb-3">
          <label class="form-label">Full Name</label>
          <input v-model="form.name" class="form-control" placeholder="Member name" />
        </div>

        <div class="mb-3">
          <label class="form-label">Phone (25078/25079...)</label>
          <input v-model="form.phone" class="form-control" placeholder="0788123456" />
        </div>

        <div class="mb-3">
          <label class="form-label">Email (optional)</label>
          <input v-model="form.email" class="form-control" placeholder="name@example.com" />
        </div>

        <div class="mb-3">
          <label class="form-label">Role</label>
          <select v-model="form.role" class="form-select">
            <option value="member">Member</option>
            <option value="treasurer">Treasurer</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="form.is_active" id="activeChk">
          <label class="form-check-label" for="activeChk">
            Active
          </label>
        </div>
      </div>

      <div class="card-footer d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary" :disabled="loading" @click="$emit('close')">Cancel</button>
        <button class="btn btn-primary" :disabled="loading" @click="save">
          {{ loading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { createMember, updateMember } from "../services/members";

export default {
  props: {
    title: { type: String, required: true },
    initial: { type: Object, default: null }, // if null => create
  },
  data() {
    return {
      loading: false,
      error: "",
      form: {
        name: "",
        phone: "",
        email: "",
        role: "member",
        is_active: true,
      },
    };
  },
  mounted() {
    if (this.initial) {
      this.form = {
        name: this.initial.name || "",
        phone: this.initial.phone || "",
        email: this.initial.email || "",
        role: this.initial.role || "member",
        is_active: !!this.initial.is_active,
      };
    }
  },
  methods: {
    async save() {
      this.loading = true;
      this.error = "";
      try {
        const payload = { ...this.form };

        if (!this.initial) {
          await createMember(payload);
        } else {
          await updateMember(this.initial.id, payload);
        }

        this.$emit("saved");
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          (e?.response?.data?.errors
            ? Object.values(e.response.data.errors).flat().join(" ")
            : "Failed to save member");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-backdrop-custom{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-card{
  border-radius: 12px;
}
</style>
